import { render, staticRenderFns } from "./index.vue?vue&type=template&id=fcd22f08&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=fcd22f08&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../szc.cycz.cc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcd22f08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/szc.cycz.cc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fcd22f08')) {
      api.createRecord('fcd22f08', component.options)
    } else {
      api.reload('fcd22f08', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=fcd22f08&scoped=true", function () {
      api.rerender('fcd22f08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/inventorySystemManagement/category/index.vue"
export default component.exports